import { portfolioDividendEfp } from '../fixtures/portfolioDividendEfp';
type HookParams = {
  portfolioId: string;
};

export const usePortfolioDividendEfpCreator =
  (currencyISO: string) =>
  ({ portfolioId }: HookParams) => {
    // setup for the future
    console.log(currencyISO, portfolioId);
    return { data: portfolioDividendEfp };
  };

export type EpfRawData = typeof portfolioDividendEfp | null | undefined;
export type EpfRawDataItem = (typeof portfolioDividendEfp)[0];
